<template>
  <v-row no-gutters>
    <dialog-customer-rank
      :dialog="dialogCustomerRank"
      :customerRank="selectedCustomerRank"
      v-on:dialog-close="onDialogClose"
    ></dialog-customer-rank>
    <v-col cols="12">
      <v-toolbar flat class="sub-toolbar" height="50px">
        <v-icon class="mr-2" color="primary" size="30">mdi-seal</v-icon>
        <v-toolbar-title class="primary--text">Customer Rank</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small outlined color="primary" @click="onNew()">
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>
      <!-- <v-toolbar color="blue darken-1" class="elevation-0 mb-1" height="3px"/> -->
      <!-- <v-alert :value="alert" :type="alertType" dismissible>{{alertMessage}}</v-alert> -->
      <v-data-table :headers="rankHeader" :items="customerRanks">
        <template v-slot:item="{ item }">
          <tr :key="item.pt_id">
            <td class="text-center data-table-style">{{ item.customer_rank_id }}</td>
            <!-- <td class="text-center data-table-style">{{ item.label }}</td> -->
            <td class="text-center data-table-style">{{ item.currency }}</td>
            <td class="text-center data-table-style">{{ item.air_freight_markup_rate }}</td>
            <td class="text-center data-table-style">{{ item.ocean_freight_fcl_markup_rate }}</td>
            <td class="text-center data-table-style">{{ item.ocean_freight_lcl_markup_rate }}</td>
            <td class="text-center data-table-style">{{ item.fwd_export_markup_rate }}</td>
            <td class="text-center data-table-style">
              <v-icon v-if="item.apply_minimum_markup" color="success">fa-check-circle</v-icon>
              <v-icon v-else color="error">fa-times-circle</v-icon>
            </td>
            <td class="text-center data-table-style">{{ item.credit_line }}</td>
            <td class="text-center data-table-style">{{ item.updated.substring(0, 10) }}</td>
            <td class="text-center data-table-style">
              <v-btn small icon color="primary" dark @click="onEdit(item)">
                <v-icon size="18">mdi-pencil</v-icon>
              </v-btn>

              <!-- <v-btn small icon color="error" dark @click="onDelete(item)" disabled>
                <v-icon>mdi-delete</v-icon>
              </v-btn>-->
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import constant from "../../const";

export default {
  data() {
    return {
      dialogCustomerRank: false,
      selectedCustomerRank: null,

      alert: false,
      alertType: "success",
      alertMessage: null,

      dataTableRowsItem: [
        10,
        25,
        50,
        { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
      ],

      rankHeader: [
        {
          text: "ID",
          align: "center",
          description: "Customer Rank ID",
          showTooltip: true,
          value: "customer_rank_id"
        },
        {
          text: "Currency",
          align: "center",
          description: "Rank currency base",
          showTooltip: true,
          value: "currency"
        },
        {
          text: "Freight (AIR)",
          align: "center",
          description: "Air freight multiplier",
          showTooltip: true,
          value: "air_freight_markup_rate"
        },
        {
          text: "Freight (FCL)",
          align: "center",
          description: "Ocean freight FCL multiplier",
          showTooltip: true,
          value: "ocean_freight_fcl_markup_rate"
        },
        {
          text: "Freight (LCL)",
          align: "center",
          description: "Ocean freight LCL multiplier",
          showTooltip: true,
          value: "ocean_freight_lcl_markup_rate"
        },
        {
          text: "Customs (Origin)",
          align: "center",
          description: "Forward Export",
          showTooltip: true,
          value: "fwd_export_markup_rate"
        },
        {
          text: "Apply Minimum",
          align: "center",
          description: "Apply Minimum",
          showTooltip: true,
          value: "apply_minimum_markup"
        },
        {
          text: "Credit line",
          align: "center",
          description: "Credit line allowed",
          showTooltip: true,
          value: "credit_line"
        },
        {
          text: "Last updated",
          align: "center",
          description: "Time last updated",
          showTooltip: true,
          value: "updated"
        },
        {
          text: "Actions",
          align: "center",
          description: "",
          showTooltip: false,
          value: "action",
          sortable: false
        }
      ],
      customerRanks: []
    };
  },

  async created() {
    // verify user token
    await this.$root.verify_user_token();

    this.initializeCustomerRankList();
  },
  mounted() {},

  methods: {
    initializeCustomerRankList: function() {
      this.$root.blockUImsg = "Loading customer ranks...";
      this.$root.blockUIshow = true;
      var response = null;

      this.$https
        .get("/api/company/rates/customer_ranks")
        .then(resp => (response = resp.data))
        .catch(err => {
          response = err.response;
        })
        .finally(() => {
          if ((response.status = constant.RESPONSE_STATUS_OK)) {
            this.customerRanks = response.data;
          }
          this.$root.blockUIshow = false;
        });
    },

    onNew: function() {
      this.selectedCustomerRank = null;
      this.dialogCustomerRank = true;
    },

    onEdit: function(customerRank) {
      this.selectedCustomerRank = customerRank;
      this.dialogCustomerRank = true;
    },

    onDelete: function(customerRank) {
      var response = null;
      this.$root.blockUImsg = "Trashing customer rank...";
      this.$root.blockUIshow = true;

      this.$https
        .delete(
          "/api/company/rates/customer_ranks/" + customerRank.customer_rank_id
        )
        .then(resp => (response = resp.data))
        .catch(err => {
          response = err.response;
        })
        .finally(() => {
          if (response != null) {
            if (response.status == constant.RESPONSE_STATUS_OK) {
              this.showSnackbar = true;
              this.snackbarColor = "success";
              this.snackbarMsg = response.msg;
            } else {
              this.showSnackbar = true;
              this.snackbarColor = "error";
              this.snackbarMsg = response.msg;
            }
          }

          this.$root.blockUIshow = false;
        });
    },

    onDialogClose: function(dialog, hasChange) {
      if (hasChange) {
        this.initializeCustomerRankList();
      }

      this.dialogCustomerRank = false;
      this.selectedCustomerRank = null;
    }
  }
};
</script>

<style>
</style>
